import { render } from "./UpdateResearchQuestion.vue?vue&type=template&id=23b6959c&scoped=true"
import script from "./UpdateResearchQuestion.vue?vue&type=script&lang=js"
export * from "./UpdateResearchQuestion.vue?vue&type=script&lang=js"

import "./UpdateResearchQuestion.vue?vue&type=style&index=0&id=23b6959c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-23b6959c"

export default script